module.exports = __webpack_public_path__ + "img/caixa.cff8a9d3.svg";